import React from "react";
import { Chip } from "@mui/material";

const STATUS_MAP = {
  PENDING: { label: "대기", color: "warning" },
  ASSIGNED: { label: "배정됨", color: "info" },
  ON_THE_WAY: { label: "이동 중", color: "primary" },
  AWAITING_APPROVAL: { label: "승인 대기", color: "secondary" },
  COMPLETED: { label: "완료", color: "success" },
  REJECTED: { label: "거절(재수거)", color: "error" },
  CANCELLED: { label: "취소", color: "error" },
};

export function getStatusChip(status) {
  const s = STATUS_MAP[status] || { label: status || "-", color: "default" };
  return <Chip label={s.label} color={s.color} size="small" />;
}

export function canAssignMarketLocation(status) {
  return ["PENDING", "ASSIGNED"].includes(status || "PENDING");
}

export function getAssignDisabledReason(status) {
  if (canAssignMarketLocation(status)) return "";
  const label = STATUS_MAP[status]?.label || status || "알 수 없음";
  return `${label} 상태의 요청은 수거업자를 배정할 수 없습니다.`;
}

export function getApiErrorMessage(error, fallback) {
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  return data?.message || data?.error || fallback;
}

export function formatItemsText(items) {
  if (!items || items.length === 0) return "-";
  return items.map((item) => `${item.name} x${item.quantity}`).join(", ");
}

export function calcTotalPrice(value) {
  if (value && !Array.isArray(value)) {
    const estimated = Number(value.estimatedTotalPrice);
    if (Number.isFinite(estimated)) return estimated;
  }
  const items = Array.isArray(value) ? value : value?.items;
  const itemTotal = (items || []).reduce(
    (sum, item) => sum + item.quantity * (item.price || 0),
    0
  );
  const extraFee = value && !Array.isArray(value) ? Number(value.extraFee) : 0;
  return itemTotal + (Number.isFinite(extraFee) ? extraFee : 0);
}

export function formatPrice(v) {
  return v != null && v > 0 ? `${v.toLocaleString("ko-KR")}원` : "0원";
}

export const locationCsvHeaders = [
  { label: "주소", key: "address" },
  { label: "상세주소", key: "detailAddress" },
  { label: "희망날짜", key: "desiredDate" },
  { label: "상태", key: "status" },
  { label: "수거자", key: "collectorName" },
  { label: "이용자", key: "userName" },
  { label: "품목", key: "_items" },
  { label: "총 금액", key: "_totalPrice" },
  { label: "등록일", key: "createdAt" },
];

export const recordCsvHeaders = [
  { label: "수거완료일", key: "_collectedAt" },
  { label: "주소", key: "address" },
  { label: "희망날짜", key: "desiredDate" },
  { label: "이용자", key: "userName" },
  { label: "수거자", key: "collectorName" },
  { label: "품목", key: "_items" },
  { label: "총 금액", key: "_totalPrice" },
  { label: "메모", key: "memo" },
];

export function toLocationCsvRow(loc) {
  return {
    ...loc,
    _items: formatItemsText(loc.items),
    _totalPrice: calcTotalPrice(loc),
    createdAt: loc.createdAt
      ? new Date(loc.createdAt).toLocaleString("ko-KR")
      : "",
  };
}

export function toRecordCsvRow(r) {
  return {
    ...r,
    _collectedAt: r.collectedAt
      ? new Date(r.collectedAt).toLocaleString("ko-KR")
      : "",
    _items: formatItemsText(r.items),
    _totalPrice: calcTotalPrice(r),
  };
}
